import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { ProductType } from 'services/api/entities/stripe/product';
import { useSubscription } from 'services/hooks';
import CustomButton from './CustomButton';

type Props = {
  productType: ProductType;
  onClick: () => void;
};

const SelectPlanButton = ({ productType, onClick }: Props) => {
  const { isFreeAccount } = useSubscription();
  const { t } = useTranslation();

  const isFreeProduct = productType === ProductType.Free;

  const isFreeProductCurrentlySelected = useMemo(
    () => isFreeAccount && isFreeProduct,
    [isFreeAccount, isFreeProduct]
  );

  const ctaText = useMemo(() => {
    if (isFreeProductCurrentlySelected) {
      return t('subscription:infoBox:currentAccountType');
    }
    if (isFreeProduct) {
      return t('subscription:infoBox:getStarted');
    }
    return t('subscription:infoBox:subscribeNow');
  }, [isFreeProduct, isFreeProductCurrentlySelected, t]);

  return (
    <CustomButton
      onClick={onClick}
      title={ctaText}
      disabled={isFreeProductCurrentlySelected}
    />
  );
};

export default SelectPlanButton;
